import React from "react";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import WhiteButton from "./WhiteButton.js";

export interface WhiteButtonDropdownItem {
  as?: "RRLink" | "button" | "a" | "span";
  icon: any;
  toggleHeading: any;
  toggleSubheading?: string;
  to?: string;
  onClick?: () => void;
  title?: string;
  target: string | undefined;
  disabled?: boolean;
  key?: string | number;
}

export default function WhiteButtonDropdown({
  toggleHeading,
  toggleSubheading,
  toggleIcon = faPen,
  id = "white-button-dropdown",
  children,
}: {
  toggleHeading: any;
  toggleSubheading?: string;
  toggleIcon?: any;
  id?: string;
  children: React.ReactNode;
}) {
  return (
    <Dropdown className="d-inline-block">
      <Dropdown.Toggle
        variant=""
        id={id}
        className="btn d-flex align-items-center  btn-white rounded-3 py-2 ps-2  border-0 mx-2 "
        style={{ minWidth: 200 }}
      >
        <span className="mx-2 d-flex align-items-center">
          <FontAwesomeIcon
            icon={toggleIcon}
            style={{ fontSize: "1.15em" }}
            className="text-purple px-1 mx-1"
          />
        </span>
        <div className="border-end border-tertiary mx-2 align-self-stretch" />
        <div className="text-start small">
          <h6 className="fw-bold mb-0">{toggleHeading}</h6>
          <span className="small opacity-50">{toggleSubheading}</span>
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu className="bg-page p-2">
        <div className="d-flex flex-column gap-2">{children}</div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
